"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssGrouperConfig = void 0;
var background_grouper_1 = require("./background-grouper");
var text_decoration_grouper_1 = require("./text-decoration-grouper");
var text_emphasis_grouper_1 = require("./text-emphasis-grouper");
var background_grouper_2 = require("./background-grouper");
/*
configures which css props ('prop') will be grouped and expanded using a specified logic instead of the default browser expand
 */
exports.cssGrouperConfig = [
    {
        prop: 'background',
        annotate: background_grouper_1.annotateBackgroundAst,
        transform: background_grouper_2.backgroundCorrection,
    },
    {
        prop: 'text-decoration',
        annotate: text_decoration_grouper_1.annotateTextDecorationAst,
    },
    {
        prop: 'text-emphasis',
        annotate: text_emphasis_grouper_1.annotateTextEmphasisAst,
    },
];
//# sourceMappingURL=shorthand-expand-config.js.map